import { take, takeLast } from 'ramda'

export const stringOmitMiddle = (fronts: number, ends: number, str: string) =>
    str.length > fronts + ends + 3 ? `${take(fronts, str)}...${takeLast(ends, str)}` : str
